import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

export const Style = makeStyles((theme: Theme) =>
  createStyles({
    "@keyframes myEffect": {
      "0%": {
        transform: "rotate(0deg) translate(0.5px,0.5px)",
      },
      "40%": {
        transform: "rotate(5deg) translate(-0.5px,0.5px)",
      },
      "80%": {
        transform: "rotate(0eg) translate(0.5px,0.5px)",
      },
      "150%": {
        transform: "rotate(-5deg) translate(-0.5px,-0.5px)",
      },
    },
    adCntnr: {
      zIndex: 999999,
      transition: "all 1s ease",
      transform: "scale(1)",
      position: "fixed",
      width: "80px",
      height: "80px",
      backgroundColor: "#009ef7",
      bottom: "30px",
      left:
        window.innerWidth > 2000
          ? "200px"
          : window.innerWidth > 2000
          ? "150px"
          : "3%",
      borderRadius: "80px",
      filter: "drop-shadow(-2px 6px 4.3px rgba(0, 0, 0, 0.48))",
      "&:hover": {
        transform: "scale(1.2)",
      },
    },
    adBack: {
      zIndex: 9,
      display: "table",
      width: "80px",
      height: "80px",
      cursor: "pointer",
      animation: `$myEffect 2s ${theme.transitions.easing.easeInOut}`,
      animationIterationCount: "infinite",
      animationDirection: "forward",
    },
    adTxt: {
      display: "table-cell",
      verticalAlign: "middle",
      textAlign: "center",
      padding: "5px",
    },
    bellInfo: {
      zIndex: 9999,
      cursor: "pointer",
      position: "fixed",
      bottom: "30px",
      left: "30px",
      backgroundColor: "#2d3cd7",
      borderRadius: "50px",
      padding: "8px",
      animationName: "sigmaFadeUp",
      animationDuration: ".4s",
      WebkitAnimationName: "sigmaFadeUp",
      WebkitAnimationDuration: ".4s",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translate3d(0, 0, 0) scale(1.2)",
      },
    },
  })
);
